const restuarant = `Asunto: Queja sobre mi mala visita al restaurante
Estimado Gerente,
Quiero contarles mi mala experiencia en su restaurante.
Cuando comí allí ayer, encontré un pelo en la comida, lo cual fue realmente asqueroso.
Además, el camarero no fue amable cuando se lo conté. Fueron groseros y no pareció importarles.
Asegúrese de que su restaurante esté limpio y que su personal sea cortés con los clientes.
Es importante asegurarse de que esto no le suceda a nadie más.
Me gustaría recibir una disculpa oficial y que me devuelvan el dinero.
También estoy pensando en hacer una denuncia oficial sobre esto,
Por favor tome las medidas necesarias para que esto no vuelva a suceder`;

export default restuarant;